const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '高清画质体验',
    desc: '支持4K超清、1080P蓝光等多种分辨率，智能适配网络环境，自动选择最佳清晰度播放',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速缓冲播放',
    desc: '自建CDN加速节点覆盖全国，多线路智能切换，告别卡顿与加载等待，即点即播流畅观影',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片源聚合',
    desc: '聚合全网主流影视站点资源，30,000+高清片源持续增长，每日更新200+热门剧集与电影',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '离线缓存下载',
    desc: '支持WiFi环境下批量下载缓存，无网络也能随时观看，通勤出行不再无聊，流量0消耗',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净观影环境',
    desc: '无弹窗、无强制广告、无需注册登录，打开即看，专注为影迷提供绿色清爽的观影空间',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            核心优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            为什么选择91影视看片APP
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            五大核心特色，打造手机影视APP标杆级观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {FEATURES.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/60 hover:border-accent-200 transition-all cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}